import { colors } from "helpers/colors";
import React from "react";
import { createUseStyles } from "react-jss";
import Offer4 from "./Offer4";

interface IProps {
  offers: any[];
}

export default function Template4(props: IProps) {
  const { offers } = props;
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {offers.map((offer) => (
        <div
          key={`template4-${offer.id}-${Math.random()}`}
          style={{
            width: 1920 / 2,
            height: 1080 / 2,
            display: "flex",
            position: "relative",
          }}
          className={"offer-container"}
        >
          <Offer4 offer={offer} />
        </div>
      ))}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    height: "100%",
    width: "100%",
    "& .offer-container": {
      boxSizing: "border-box",
      "&:nth-child(1)": {
        borderRight: `3px solid ${colors.imko}`,
        borderBottom: `3px solid ${colors.imko}`,
      },
      "&:nth-child(2)": {
        borderLeft: `3px solid ${colors.imko}`,
        borderBottom: `3px solid ${colors.imko}`,
      },
      "&:nth-child(3)": {
        borderRight: `3px solid ${colors.imko}`,
        borderTop: `3px solid ${colors.imko}`,
      },
      "&:nth-child(4)": {
        borderLeft: `3px solid ${colors.imko}`,
        borderTop: `3px solid ${colors.imko}`,
      },
    },
  },
});
